angular.module("Main").controller("KursplanWeekController", ["$rootScope", "$scope", "$window", "$document", "$timeout", "$state", "$stateParams", "$localStorage", "$uibModal", "BookingService",
    "SessionService",
    function ($rootScope, $scope, $window, $document, $timeout, $state, $stateParams, $localStorage, $uibModal, BookingService, SessionService) {
        var vm = this;
        vm.isMember = false;
        vm.now = new Date();
        vm.notTodayStyle = {opacity: 0.6};
        vm.hours = [];
        vm.isLoading = false;
        // for (var i = 0; i <= 24; i++) {
        //     if (i < 10) {
        //         vm.hours.push('0' + i + ':00')
        //     } else {
        //         vm.hours.push(i + ':00');
        //     }
        // }


        function getTicksForSlider(sliderStart, sliderEnde) {
            var quarterHours = ["00", "30"];
            vm.hours = [];
            if (sliderStart) {
                let startSplit = sliderStart.split(":");
                let startHour = startSplit[0];
                let startMinute = startSplit[1];
                let endeSplit = sliderEnde.split(":");
                let endeHour = endeSplit[0];
                let endeMinute = endeSplit[1];
                if (startMinute !== '30') {
                    if (startHour.charAt(0) === '0') {
                        let ind = startHour.charAt(1);
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(ind); i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(ind); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    } else {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(startHour) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(startHour); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    }
                }
                if (startMinute === "30") {
                    vm.hours.push(sliderStart)
                    let ind = startHour.charAt(1);
                    if (startHour.charAt(0) === '0') {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(ind) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(ind) + 1; i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }

                    } else {
                        if (endeHour.charAt(0) === '0') {
                            for (var i = _.parseInt(startHour) + 1; i <= _.parseInt(endeHour[1]); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        } else {
                            for (var i = _.parseInt(startHour); i <= _.parseInt(endeHour); i++) {
                                for (var j = 0; j < 2; j++) {
                                    var time = i + ":" + quarterHours[j];
                                    if (i < 10) {
                                        time = "0" + time;
                                    }
                                    vm.hours.push(time);
                                }
                            }
                            if (endeMinute === '00') {
                                vm.hours.pop()
                            }
                            return vm.hours
                        }
                    }
                }
            } else {
                getTicksForSliderDefault()
            }
        }


        function getTicksForSliderDefault() {
            var quarterHours = ["00", "30"];
            vm.hours = [];
            for (var i = 0; i < 24; i++) {
                for (var j = 0; j < 2; j++) {
                    var time = i + ":" + quarterHours[j];
                    if (i < 10) {
                        time = "0" + time;
                    }
                    vm.hours.push(time);
                }
            }
            vm.hours.push("24:00");
            return vm.hours
        }


        loadView();
        loadCurrency();

        //loadConfigs();

        function loadView() {
            if ($window.innerWidth > 700) {
                vm.weekView = true;
                vm.template = "app/Main/views/kursplanWeek.html";
            } else if ($window.innerWidth < 700) {
                vm.weekView = false;
                vm.template = "app/Main/views/kursplanDay.html";
            }
        }

        function loadCurrency() {
            BookingService.getCurrency().then(function (data) {
                vm.currency = data;
                if (vm.currency.Waehrung === "EUR")
                    vm.currency.Waehrung = "€";
            })
        }

        var loginHandler = $rootScope.$on("login", function () {
            checkUser();
        });
        var logoutHandler = $rootScope.$on("logout", function () {
            vm.isMember = false;
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            unregisterEventHandler();
            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
            } else {
                var uuid = $stateParams.id;
            }
            SessionService.setAuthDataId($stateParams.cid, uuid);
            $state.go('kursplan', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: uuid});

        });

        if (!SessionService.getSessionId()) {
            if (_.isUndefined($stateParams.id)) {
                SessionService.setAuthDataId($stateParams.cid, false);
                $state.go('kursplan', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: false});
            } else {
                SessionService.setAuthDataId($stateParams.cid, $stateParams.id);
                $state.go('kursplan', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id});
            }

        } else
            initRessourcen();

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        if (screen.width < 600) {
            vm.isMobilePhone = true;
        } else
            vm.isMobilePhone = false;

        vm.setNewStartDate = function (s) {
            var dayWeek = s.getDay();
            vm.startDate = new Date(s);
            if (s < new Date()) {
                vm.startDate = new Date();
            }
            var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            getWeekPlanSkipingWeek(vm.startDate, endDate);
        };


        vm.setNewDayDate = function (s) {
            vm.date = new Date(s.getFullYear(), s.getMonth(), s.getDate());
            initPlanDay(vm.date);
        };

        function checkUser() {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
                }
            }
            vm.isMember = ($localStorage.user && $localStorage.user.username && $localStorage.user.username !== '') ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.username = $localStorage.user ? $localStorage.user.username : null;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
        }

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });


        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.layoutSettings.AuslastungNichtAnzeigenKB = data.AuslastungNichtAnzeigenKB;
                vm.layoutSettings.NavigationBuchbareWoche = data.NavigationBuchbareWoche;
                vm.layoutSettings.AnzahlWochenZumPruefen = data.AnzahlWochenZumPruefen;
                vm.layoutSettings.MRVerbergenKB = data.MRVerbergenKB;
                vm.layoutSettings.NMRVerbergenKB = data.NMRVerbergenKB;
                vm.layoutSettings.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
                getKursbuchungLayouKonfiguration();
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
                vm.checkedFilter = {color: vm.kursbuchungConfig.Step1KursItemHintergrund};
                vm.activeBackground = {background: vm.kursbuchungConfig.Step1ButtonsHintergrundAktiv, color: vm.kursbuchungConfig.Step1ButtonsSchriftAktiv};
                vm.notActiveBackground = {background: vm.kursbuchungConfig.Step1ButtonsHintergrund, color: vm.kursbuchungConfig.Step1ButtonsSchrift};
                vm.activeBackgroundWochentage = {
                    background: vm.kursbuchungConfig.Step1WochentageHintergrundAktiv,
                    color: vm.kursbuchungConfig.Step1WochentageSchriftAktiv
                };
                vm.notActiveBackgroundWochentage = {
                    background: vm.kursbuchungConfig.Step1WochentageHintergrund,
                    color: vm.kursbuchungConfig.Step1WochentageSchrift
                };
            })
        }

        vm.loadBackgrounds = function () {
            if (vm.SliderActiv === 1)
                setTimeout(function () {
                    $scope.$broadcast('rzSliderForceRender');
                    loadConfigs();
                    changeBackground();
                }, 1);

        };

        function changeBackground() {
            let b = document.getElementsByClassName('rz-tick');
            _.forEach(b, function (tick) {
                tick.style.backgroundColor = vm.kursbuchungConfig.TimeSliderInaktiv;
            });
            let a = document.getElementsByClassName('rz-tick rz-selected');
            _.forEach(a, function (tick) {
                tick.style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            });

            document.getElementsByClassName('rz-bar')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderInaktiv;
            document.getElementsByClassName('rz-pointer-min')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            document.getElementsByClassName('rz-pointer-max')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;
            document.getElementsByClassName('rz-selection')[0].style.backgroundColor = vm.kursbuchungConfig.TimeSliderAktiv;

        }

        async function checkKurse() {
            let now = new Date();
            let dayWeek = now.getDay();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.formatedToday = moment(vm.today).format('YYYY-MM-DD').toString();
            if (dayWeek === 0) {
                vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
                var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            } else {
                vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayWeek - 1));
                var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            }

            if (vm.layoutSettings.NavigationBuchbareWoche) {
                if (vm.weekView === true && $window.innerWidth > 700) {
                    await initPlan(vm.startDate, endDate);
                } else if (vm.weekView === false && $window.innerWidth < 700) {
                    let now = new Date();
                    let dayWeek = now.getDay();
                    vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                    vm.formatedToday = moment(vm.today).format('YYYY-MM-DD').toString();
                    if (dayWeek === 0) {
                        vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
                        var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
                    } else {
                        vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayWeek - 1));
                        var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
                    }

                    await getBuchbareKurseForDay(vm.startDate, endDate)

                }
            }
            else {
                if (vm.weekView === true && $window.innerWidth > 700) {
                    await getWeekPlanSkipingWeek(vm.startDate, endDate)
                }
                else if (vm.weekView === false && $window.innerWidth < 700) {
                    vm.weekView = false;
                    let now = new Date();
                    vm.date = new Date(now);
                    await initPlanDay(vm.date);

                }
            }

            vm.datepickerOptions = {
                minDate: new Date()
            };
        }

        async function start() {
            try {
                await checkUser();
                await checkKurse();
            }
            catch {

            }
        }

        vm.openLegende = false;
        vm.openFilter = false;
        //vm.weekView = true;
        vm.date = vm.today;


        function getBuchbareKurseForDay(startDate, endDate) {
            vm.isLoading = true;
            vm.now = new Date();
            vm.cookies = SessionService.checkSession();
            vm.kurseInactiv = false;

            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
                vm.isLoading = false;
            } else {
                var uuid = $stateParams.id;
                vm.isLoading = false;
            }
            BookingService.getKurse(startDate, endDate, uuid, true, vm.layoutSettings.AnzahlWochenZumPruefen).then(async function (kurse) {
                vm.startDate = startDate;
                if (kurse.LinkIdNotFound === true) {
                    vm.idNotFound = true;
                    vm.isLoading = false;
                } else {
                    if (kurse.IsInactiv === true) {
                        vm.kurseInactiv = true;
                        vm.isInFuture = kurse.IsInFuture;
                        vm.isInPast = kurse.IsInPast;
                        vm.isLoading = false;
                        if (kurse.IsInFuture === true) {
                            vm.futureDate = kurse.FutureDate;
                        }
                    } else {
                        vm.stepsArray = [];
                        vm.stepsArray = await getTicksForSlider(kurse.Daten.kursInfo.SliderData.SliderStart, kurse.Daten.kursInfo.SliderData.SliderEnde);
                        vm.SliderActiv = kurse.Daten.kursInfo.SliderData.IsSlider;
                        vm.slider = {
                            minValue: kurse.Daten.kursInfo.SliderData.SliderStart ? kurse.Daten.kursInfo.SliderData.SliderStart : "00:00",
                            maxValue: kurse.Daten.kursInfo.SliderData.SliderEnde ? kurse.Daten.kursInfo.SliderData.SliderEnde : "24:00",
                            options: {
                                showTicks: true,
                                stepsArray: vm.stepsArray,
                                draggableRange: true,
                                onChange: function () {
                                    changeBackground()
                                },
                            }
                        };
                        if (kurse.Daten.kursInfo.SelectionTerminarten === false) {
                            initTerminarten();
                        } else {
                            let ids = kurse.Daten.kursInfo.SelectionTerminartenIds;
                            initTerminartenSelection(ids);
                        }
                        vm.AllRessourcesMapped = _.uniqBy(_.flatten(_.map(kurse.Daten.alleKurse, 'AllRessources')), 'Id');
                        vm.AllRessourcesMappedMitarbeiter = _.sortBy(_.filter(vm.AllRessourcesMapped, {Mitarbeiter: 1}), 'Bezeichnung');
                        vm.AllRessourcesMappedNichtMitarbeiter = _.sortBy(_.filter(vm.AllRessourcesMapped, {Mitarbeiter: 0}), 'Bezeichnung');
                        _.forEach(kurse.Daten.alleKurse, function (k) {
                            k.MitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                            k.NichtMitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                            if(vm.layoutSettings.MRVerbergenKB) {
                                k.AllRessources = k.NichtMitarbeiterRessource;
                            }
                            if(vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = k.MitarbeiterRessource;
                            }
                            if(!vm.layoutSettings.MRVerbergenKB && !vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = _.concat(k.MitarbeiterRessource, k.NichtMitarbeiterRessource);
                            }
                            if(vm.layoutSettings.MRVerbergenKB && vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = [];
                            }
                            k.TeilnehmerGebucht = _.subtract(k.MaximaleAnzahlTeilnehmer, k.FreiePlaetze);
                            k.RessourcenIds = _.map(k.AllRessources, 'Id');
                            k.Start = new Date(k.Start);
                            k.Ende = new Date(k.Ende);
                            k.completeStart = k.Start;
                            k.completeEnde = k.Ende;
                            k.Tag = new Date(k.Start);
                            k.TagDate = new Date(k.Tag.getFullYear(), k.Tag.getMonth(), k.Tag.getDate());
                            k.Day = (k.TagDate).getDay() - 1;
                            if (k.Start.getDate() === k.Ende.getDate()) {
                                k.IsSameDay = true;
                                k.Start = moment(k.Start).format('HH:mm').toString();
                                k.Ende = moment(k.Ende).format('HH:mm').toString();
                            }
                            else {
                                k.IsSameDay = false;
                                k.Start = moment(k.Start).format('DD.MM HH:mm').toString();
                                k.Ende = moment(k.Ende).format('DD.MM HH:mm').toString();
                            }
                            k.Tag = moment(k.Tag).format('YYYY-MM-DD').toString();
                            vm.listRes = [];
                        });
                        vm.weekDates = [];
                        vm.kurseAll = _.sortBy(kurse.Daten.alleKurse, 'completeStart');
                        vm.kurseInFuture = vm.kurseAll.filter(kurs => kurs.completeStart > vm.today);
                        vm.kurseAlInFutureSorted = _.sortBy(vm.kurseInFuture, 'completeStart');
                        vm.date = new Date(vm.kurseAlInFutureSorted[0].completeStart);
                        vm.tag = vm.kurseAlInFutureSorted[0].Tag;
                        vm.isLoading = false;
                        vm.kurse = searchAllForDay(vm.kurseAlInFutureSorted, vm.tag);
                    }
                }
            })
        }

        vm.setDayView = function () {
            vm.weekView = false;
            var now = new Date();
            vm.date = new Date(now);
            vm.template = "app/Main/views/kursplanDay.html";
            if (vm.layoutSettings.NavigationBuchbareWoche) {
                let now = new Date();
                let dayWeek = now.getDay();
                vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                vm.formatedToday = moment(vm.today).format('YYYY-MM-DD').toString();
                if (dayWeek === 0) {
                    vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
                    var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
                } else {
                    vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayWeek - 1));
                    var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
                }
                getBuchbareKurseForDay(vm.date, endDate);
            }
            else {
                initPlanDay(vm.date);
            }

        };

        vm.setWeekView = function () {
            vm.weekView = true;
            vm.template = "app/Main/views/kursplanWeek.html";
            let now = new Date();
            let dayWeek = now.getDay();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.formatedToday = moment(vm.today).format('YYYY-MM-DD').toString();
            if (dayWeek === 0) {
                vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
                var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            } else {
                vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayWeek - 1));
                var endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            }
            if (vm.layoutSettings.NavigationBuchbareWoche) {
                initPlan(vm.startDate, endDate);
            }
            else {
                getWeekPlanSkipingWeek(vm.startDate, endDate)
            }
        }

        vm.openCloseLegendeIcons = function () {
            if (vm.openLegende === false) {
                vm.openLegende = true;
            } else {
                vm.openLegende = false;
            }
        };

        vm.openFilters = function () {
            vm.openFilter = true;
        };

        vm.closeFilters = function () {
            vm.openFilter = false;
        };

        vm.gotoDateRelativeWeek = function (offset, start) {
            vm.startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate() + offset);
            let endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            getWeekPlanSkipingWeek(vm.startDate, endDate);

        };

        vm.goTodayWeek = function () {
            let now = new Date();
            let dayWeek = now.getDay();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (dayWeek - 1));
            let endDate = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6);
            getWeekPlanSkipingWeek(vm.startDate, endDate);
        };

        vm.gotoDateRelativeDay = function (offset) {
            let date = moment(vm.date).add(offset, 'd');
            vm.date = new Date(date);
            initPlanDay(vm.date);
        };

        vm.goTodayDay = function () {
            var now = new Date();
            vm.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            vm.date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            initPlanDay(vm.date);
        };

        vm.clearResource = function (resType) {
            if (vm.selectedAll[resType]) {
                _.forEach(vm.appointmentResources[resType], function (value) {
                    value.selected = false;
                });
                initPlan();
            }
        };

        vm.selectTerminart = function (terminartNr) {
            let index = _.findIndex(vm.selectedTerminarten, function (value) {
                return value == terminartNr;
            });
            if (index >= 0)
                _.pullAt(vm.selectedTerminarten, index);
            else
                vm.selectedTerminarten.push(terminartNr);

            initPlan(new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate() + 6));
        };

        function initRessourcen() {
            BookingService.getAllRessources().then(function (data) {
                vm.ressourcenArtMitarbeiter = _.filter(data, {'MitarbeiterRessource': 1});
                vm.ressourcenNichtMitarbeiter = _.filter(data, {'MitarbeiterRessource': 0});
                var ressourcenMitarbeiter = _.flatten(_.map(vm.ressourcenArtMitarbeiter, 'Ressourcen'));
                vm.mitarbeiterRessourcen = _.uniqBy(_.map(ressourcenMitarbeiter, 'Ressource'), "Nr");
                var ressourcenNichtMitarbeiter = _.flatten(_.map(vm.ressourcenNichtMitarbeiter, 'Ressourcen'));
                vm.nichtmitarbeiterRessourcen = _.uniqBy(_.map(ressourcenNichtMitarbeiter, 'Ressource'), "Nr");
                vm.ressources = _.concat(vm.mitarbeiterRessourcen, vm.nichtmitarbeiterRessourcen);
            }).then(function () {
                BookingService.loadLayoutConfiguration().then(function (data) {
                    vm.layoutSettings = angular.fromJson(data.Layout);
                    vm.layoutSettings.AuslastungNichtAnzeigenKB = data.AuslastungNichtAnzeigenKB;
                    vm.layoutSettings.NavigationBuchbareWoche = data.NavigationBuchbareWoche;
                    vm.layoutSettings.AnzahlWochenZumPruefen = data.AnzahlWochenZumPruefen;
                    vm.layoutSettings.MRVerbergenKB = data.MRVerbergenKB;
                    vm.layoutSettings.NMRVerbergenKB = data.NMRVerbergenKB;
                    vm.layoutSettings.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
                    getKursbuchungLayouKonfiguration();
                }).then(function () {
                    start()
                })
            })
        }

        function initTerminarten() {
            BookingService.getTerminarten().then(function (data) {
                vm.terminarten = data;
                if (_.isNil(vm.selectedTerminarten)) {
                    vm.selectedTerminarten = [];
                    _.forEach(vm.terminarten, function (t) {
                        var selected = _.filter(t.Typen, {'selected': true});
                        if (selected.length > 0) {
                            vm.selectedTerminarten.push(_.map(_.filter(t.Typen, {'selected': true}), 'Id'));
                        } else {
                            vm.selectedTerminarten = [];
                        }
                    });
                }
            })
        }

        function initTerminartenSelection(ids) {
            BookingService.getTerminartenSelection(ids).then(function (data) {
                vm.terminarten = data;
                if (_.isNil(vm.selectedTerminarten)) {
                    vm.selectedTerminarten = [];
                    _.forEach(vm.terminarten, function (t) {
                        var selected = _.filter(t.Typen, {'selected': true});
                        if (selected.length > 0) {
                            vm.selectedTerminarten.push(_.map(_.filter(t.Typen, {'selected': true}), 'Id'));
                        } else {
                            vm.selectedTerminarten = [];
                        }
                    });
                }
            })
        }

        vm.uncheckAllTerminart = function () {
            vm.selectedTerminarten = [];
        };

        vm.checkItemTerminart = function (k, id) {
            var checked = false;
            if (vm.selectedTerminarten.length > 0) {
                _.forEach(vm.selectedTerminarten, function (s) {
                    if (_.includes(vm.selectedTerminarten, id)) {
                        checked = true;
                        k.Checked = true;
                        vm.terminartFilterChecked = true;
                    }
                });
                return checked;
            } else {
                k.Checked = false;
                checked = false;
                vm.terminartFilterChecked = false;
            }
        };

        vm.checkTerminart = function (id) {
            if (!_.includes(vm.selectedTerminarten, id)) {
                vm.selectedTerminarten.push(id);
            } else {
                _.pull(vm.selectedTerminarten, id);
            }
        };

        vm.ressourcenChecked = _.map(_.filter(vm.AllRessourcesMapped, {'checked': true}), 'RessourceNr');

        vm.uncheckAllRessources = function () {
            vm.ressourcenChecked = [];
        };

        vm.checkItem = function (r, id) {
            var checked = false;
            if (vm.ressourcenChecked.length > 0) {
                if (_.includes(vm.ressourcenChecked, id)) {
                    checked = true;
                    r.Checked = true;
                    vm.trainerFilterChecked = true;
                }
                return checked;
            } else {
                r.Checked = false;
                checked = false;
                vm.trainerFilterChecked = false;
            }
        };

        vm.checkRessource = function (id) {
            if (!_.includes(vm.ressourcenChecked, id)) {
                vm.ressourcenChecked.push(id);
            } else {
                _.pull(vm.ressourcenChecked, id);
            }
        };

        vm.checkedSonstige = [];

        vm.uncheckAllSonstige = function () {
            vm.checkedSonstige = [];
        };
        vm.checkItemSonstige = function (nr) {
            var checked = false;
            if (vm.checkedSonstige.length > 0) {
                if (_.includes(vm.checkedSonstige, nr)) {
                    checked = true;
                    if (nr === 1) {
                        vm.sonstige1FilterChecked = true;
                        vm.sonstige2FilterChecked = false;
                    } else {
                        vm.sonstige1FilterChecked = false;
                        vm.sonstige2FilterChecked = true;
                    }
                }
                return checked;
            }
        };
        vm.checkSonstige = function (nr) {
            if (!_.includes(vm.checkedSonstige, nr)) {
                vm.checkedSonstige.push(nr);
            } else {
                _.pull(vm.checkedSonstige, nr)
            }
        };

        function initPlanDay(date) {
            vm.isLoading=true;
            if (vm.layoutSettings.AnzahlWochenZumPruefen)
                vm.now = new Date();
            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
                vm.isLoading = false;
            } else if ($stateParams.id) {
                var uuid = $stateParams.id;
                vm.isLoading = false;
            }
            vm.kurseInactiv = false;
            vm.isNotFound = false;
            vm.weekView = false;
            vm.template = "app/Main/views/kursplanDay.html";
            BookingService.getKurseDay(date, uuid).then(async function (kurse) {
                if (kurse.Daten.LinkIdNotFound === true) {
                    vm.idNotFound = true;
                    vm.isLoading= false;
                } else {
                    if (kurse.Daten.IsInactiv === true) {
                        vm.kurseInactiv = true;
                        vm.isLoading = false;
                    } else {
                        vm.stepsArray = [];
                        vm.stepsArray = await getTicksForSlider(kurse.Daten.kursInfo.SliderData.SliderStart, kurse.Daten.kursInfo.SliderData.SliderEnde);
                        vm.SliderActiv = kurse.Daten.kursInfo.SliderData.IsSlider;
                        vm.slider = {
                            minValue: kurse.Daten.kursInfo.SliderData.SliderStart ? kurse.Daten.kursInfo.SliderData.SliderStart : "00:00",
                            maxValue: kurse.Daten.kursInfo.SliderData.SliderEnde ? kurse.Daten.kursInfo.SliderData.SliderEnde : "24:00",
                            options: {
                                showTicks: true,
                                stepsArray: vm.stepsArray,
                                draggableRange: true,
                                onChange: function () {
                                    changeBackground()
                                },
                            }
                        };
                        if (kurse.Daten.kursInfo.SelectionTerminarten === false) {
                            initTerminarten();
                        } else {
                            let ids = kurse.Daten.kursInfo.SelectionTerminartenIds;
                            initTerminartenSelection(ids);
                        }
                        vm.AllRessourcesMapped = _.uniqBy(_.flatten(_.map(kurse.Daten.allKurse, 'AllRessources')), 'Id');
                        vm.AllRessourcesMappedMitarbeiter = _.filter(vm.AllRessourcesMapped, {MitarbeiterRessource: 1});
                        vm.AllRessourcesMappedNichtMitarbeiter = _.filter(vm.AllRessourcesMapped, {MitarbeiterRessource: 0});
                        _.forEach(kurse.Daten.allKurse, function (k) {
                            BookingService.getImage(k.Terminart_Nr).then(function (data) {
                                if (data) {
                                    k.Image = data;
                                } else {
                                    k.Image = null;
                                }

                            });
                            //ToDo MRVerbergen && NMRVerbergen
                            k.MitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                            k.NichtMitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                            if(vm.layoutSettings.MRVerbergenKB) {
                                k.AllRessources = k.NichtMitarbeiterRessource;
                            }
                            if(vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = k.MitarbeiterRessource;
                            }
                            if(!vm.layoutSettings.MRVerbergenKB && !vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = _.concat(k.MitarbeiterRessource, k.NichtMitarbeiterRessource);
                            }
                            if(vm.layoutSettings.MRVerbergenKB && vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = [];
                            }
                            k.TeilnehmerGebucht = _.subtract(k.MaximaleAnzahlTeilnehmer, k.FreiePlaetze)
                            k.Start = new Date(k.Start);
                            k.Ende = new Date(k.Ende);
                            k.completeStart = k.Start;
                            k.completeEnde = k.Ende;
                            k.Tag = new Date(k.Start);
                            k.TagDate = new Date(k.Tag.getFullYear(), k.Tag.getMonth(), k.Tag.getDate());
                            k.Day = (k.TagDate).getDay() - 1;
                            if (k.Start.getDate() === k.Ende.getDate()) {
                                k.IsSameDay = true;
                                k.Start = moment(k.Start).format('HH:mm').toString();
                                k.Ende = moment(k.Ende).format('HH:mm').toString();
                            }
                            else {
                                k.IsSameDay = false;
                                k.Start = moment(k.Start).format('DD.MM HH:mm').toString();
                                k.Ende = moment(k.Ende).format('DD.MM HH:mm').toString();
                            }
                            k.Tag = moment(k.Tag).format('YYYY-MM-DD').toString();
                        });
                        vm.isLoading = false;
                        vm.kurse = _.sortBy(kurse.Daten.allKurse, 'Start');
                    }
                }
            })
        }

        function getWeekPlanSkipingWeek(startDate, endDate) {
            vm.isLoading = true;
            vm.now = new Date();
            vm.cookies = SessionService.checkSession();
            vm.kurseInactiv = false;

            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
                vm.isLoading = false;
            } else {
                var uuid = $stateParams.id;
                vm.isLoading = false;
            }


            BookingService.getKurse(startDate, endDate, uuid, false, vm.layoutSettings.AnzahlWochenZumPruefen).then(async function (kurse) {
                vm.startDate = startDate;
                if (kurse.LinkIdNotFound === true) {
                    vm.idNotFound = true;
                    vm.isLoading = false;
                } else {
                    if (kurse.IsInactiv === true) {
                        vm.kurseInactiv = true;
                        vm.isInFuture = kurse.IsInFuture;
                        vm.isInPast = kurse.IsInPast;
                        vm.isLoading = false;
                        if (kurse.IsInFuture === true) {
                            vm.futureDate = kurse.FutureDate;
                        }
                    } else {
                        vm.stepsArray = [];
                        vm.stepsArray = await getTicksForSlider(kurse.Daten.kursInfo.SliderData.SliderStart, kurse.Daten.kursInfo.SliderData.SliderEnde);
                        vm.SliderActiv = kurse.Daten.kursInfo.SliderData.IsSlider;
                        vm.slider = {
                            minValue: kurse.Daten.kursInfo.SliderData.SliderStart ? kurse.Daten.kursInfo.SliderData.SliderStart : "00:00",
                            maxValue: kurse.Daten.kursInfo.SliderData.SliderEnde ? kurse.Daten.kursInfo.SliderData.SliderEnde : "24:00",
                            options: {
                                showTicks: true,
                                stepsArray: vm.stepsArray,
                                draggableRange: true,
                                onChange: function () {
                                    changeBackground()
                                },
                            }
                        };
                        if (kurse.Daten.kursInfo.SelectionTerminarten === false) {
                            initTerminarten();
                        } else {
                            let ids = kurse.Daten.kursInfo.SelectionTerminartenIds;
                            initTerminartenSelection(ids);
                        }
                        vm.AllRessourcesMapped = _.uniqBy(_.flatten(_.map(kurse.Daten.allKurse, 'AllRessources')), 'Id');
                        vm.AllRessourcesMappedMitarbeiter = _.filter(vm.AllRessourcesMapped, {Mitarbeiter: 1});
                        vm.AllRessourcesMappedNichtMitarbeiter = _.filter(vm.AllRessourcesMapped, {Mitarbeiter: 0});
                        _.forEach(kurse.Daten.allKurse, function (k) {
                            k.MitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                            k.NichtMitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                            if(vm.layoutSettings.MRVerbergenKB) {
                                k.AllRessources = k.NichtMitarbeiterRessource;
                            }
                            if(vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = k.MitarbeiterRessource;
                            }
                            if(!vm.layoutSettings.MRVerbergenKB && !vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = _.concat(k.MitarbeiterRessource, k.NichtMitarbeiterRessource);
                            }
                            if(vm.layoutSettings.MRVerbergenKB && vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = [];
                            }
                            k.TeilnehmerGebucht = _.subtract(k.MaximaleAnzahlTeilnehmer, k.FreiePlaetze)
                            k.RessourcenIds = _.map(k.AllRessources, 'Id');
                            k.Start = new Date(k.Start);
                            k.Ende = new Date(k.Ende);
                            k.completeStart = k.Start;
                            k.completeEnde = k.Ende;
                            k.Tag = new Date(k.Start);
                            k.TagDate = new Date(k.Tag.getFullYear(), k.Tag.getMonth(), k.Tag.getDate());
                            k.Day = (k.TagDate).getDay() - 1;
                            if (k.Start.getDate() === k.Ende.getDate()) {
                                k.IsSameDay = true;
                                k.Start = moment(k.Start).format('HH:mm').toString();
                                k.Ende = moment(k.Ende).format('HH:mm').toString();
                            }
                            else {
                                k.IsSameDay = false;
                                k.Start = moment(k.Start).format('DD.MM HH:mm').toString();
                                k.Ende = moment(k.Ende).format('DD.MM HH:mm').toString();
                            }
                            k.Tag = moment(k.Tag).format('YYYY-MM-DD').toString();
                            vm.listRes = [];
                        });
                        vm.weekDates = [];
                        vm.kurseAll = _.sortBy(kurse.Daten.allKurse, 'Start');


                        var start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                        for (var i = 0; i < 7; ++i) {
                            vm.weekDates.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                            var tag = start.getDate();
                            start.setDate(tag + 1);
                        }
                        vm.isLoading = false;
                        vm.kursDaten = buildWeek(vm.kurseAll, startDate);
                    }
                }
            })

            function buildWeek(kurse) {
                var planRows = [];
                var row = new Array(7);
                _.forEach(kurse, function (kurseProStart) {
                    var tag = new Date(kurseProStart.Tag);
                    var index = _.findIndex(vm.weekDates, function (date) {
                        return (date.getFullYear() == tag.getFullYear()) && (date.getMonth() == tag.getMonth()) && (date.getDate() == tag.getDate());
                    });

                    if (_.isNil(row[index]))
                        row[index] = [];
                    row[index].push(kurseProStart);
                });
                planRows.push(row);

                return planRows;

            }
        }

        function searchAllForDay(kurse, tag) {
            let kurseAll = [];
            _.forEach(kurse, function (kurs) {
                if (kurs.Tag === tag)
                    kurseAll.push(kurs);
            })
            return kurseAll;

        }

        function initPlan(startDate, endDate) {
            vm.isLoading = true;
            vm.now = new Date();
            vm.cookies = SessionService.checkSession();
            vm.kurseInactiv = false;

            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
                vm.isLoading = false;
            } else {
                var uuid = $stateParams.id;
                vm.isLoading = false;
            }


            BookingService.getKurse(startDate, endDate, uuid, true, vm.layoutSettings.AnzahlWochenZumPruefen).then(async function (kurse) {
                vm.startDate = startDate;
                if (kurse.LinkIdNotFound === true) {
                    vm.idNotFound = true;
                    vm.isLoading = false;
                } else {
                    if (kurse.IsInactiv === true) {
                        vm.kurseInactiv = true;
                        vm.isInFuture = kurse.IsInFuture;
                        vm.isInPast = kurse.IsInPast;
                        vm.isLoading = false;
                        if (kurse.IsInFuture === true) {
                            vm.futureDate = kurse.FutureDate;
                        }
                    } else {
                        if (kurse.KW > 0) {
                            vm.startDate = new Date(moment(startDate).add(7 * (kurse.KW), 'days'));
                        }
                        vm.stepsArray = await getTicksForSlider(kurse.Daten.kursInfo.SliderData.SliderStart, kurse.Daten.kursInfo.SliderData.SliderEnde);
                        vm.SliderActiv = kurse.Daten.kursInfo.SliderData.IsSlider;
                        vm.slider = {
                            minValue: kurse.Daten.kursInfo.SliderData.SliderStart ? kurse.Daten.kursInfo.SliderData.SliderStart : "00:00",
                            maxValue: kurse.Daten.kursInfo.SliderData.SliderEnde ? kurse.Daten.kursInfo.SliderData.SliderEnde : "24:00",
                            options: {
                                showTicks: true,
                                stepsArray: vm.stepsArray,
                                draggableRange: true,
                                onChange: function () {
                                    changeBackground()
                                },
                            }
                        };
                        if (kurse.Daten.kursInfo.SelectionTerminarten === false) {
                            initTerminarten();
                        } else {
                            let ids = kurse.Daten.kursInfo.SelectionTerminartenIds;
                            initTerminartenSelection(ids);
                        }
                        vm.AllRessourcesMapped = _.uniqBy(_.flatten(_.map(kurse.Daten.alleKurse, 'AllRessources')), 'Id');
                        vm.AllRessourcesMappedMitarbeiter = _.filter(vm.AllRessourcesMapped, {Mitarbeiter: 1});
                        vm.AllRessourcesMappedNichtMitarbeiter = _.filter(vm.AllRessourcesMapped, {Mitarbeiter: 0});
                        _.forEach(kurse.Daten.alleKurse, function (k) {
                            k.MitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                            k.NichtMitarbeiterRessource = _.sortBy(_.filter(k.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                            if(vm.layoutSettings.MRVerbergenKB) {
                                k.AllRessources = k.NichtMitarbeiterRessource;
                            }
                            if(vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = k.MitarbeiterRessource;
                            }
                            if(!vm.layoutSettings.MRVerbergenKB && !vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = _.concat(k.MitarbeiterRessource, k.NichtMitarbeiterRessource);
                            }
                            if(vm.layoutSettings.MRVerbergenKB && vm.layoutSettings.NMRVerbergenKB) {
                                k.AllRessources = [];
                            }
                            k.TeilnehmerGebucht = _.subtract(k.MaximaleAnzahlTeilnehmer, k.FreiePlaetze)
                            k.RessourcenIds = _.map(k.AllRessources, 'Id');
                            k.Start = new Date(k.Start);
                            k.Ende = new Date(k.Ende);
                            k.completeStart = k.Start;
                            k.completeEnde = k.Ende;
                            k.Tag = new Date(k.Start);
                            k.TagDate = new Date(k.Tag.getFullYear(), k.Tag.getMonth(), k.Tag.getDate());
                            k.Day = (k.TagDate).getDay() - 1;
                            if (k.Start.getDate() === k.Ende.getDate()) {
                                k.IsSameDay = true;
                                k.Start = moment(k.Start).format('HH:mm').toString();
                                k.Ende = moment(k.Ende).format('HH:mm').toString();
                            }
                            else {
                                k.IsSameDay = false;
                                k.Start = moment(k.Start).format('DD.MM HH:mm').toString();
                                k.Ende = moment(k.Ende).format('DD.MM HH:mm').toString();
                            }
                            k.Tag = moment(k.Tag).format('YYYY-MM-DD').toString();
                            vm.listRes = [];
                        });
                        vm.weekDates = [];
                        vm.kurseAll = _.sortBy(kurse.Daten.alleKurse, 'Start');


                        var start = new Date(vm.startDate.getFullYear(), vm.startDate.getMonth(), vm.startDate.getDate());
                        for (var i = 0; i < 7; ++i) {
                            vm.weekDates.push(new Date(start.getFullYear(), start.getMonth(), start.getDate()));
                            var tag = start.getDate();
                            start.setDate(tag + 1);
                        }
                        vm.isLoading = false;
                        vm.kursDaten = buildWeek(vm.kurseAll, vm.startDate);
                    }
                }
            });

            function buildWeek(kurse) {
                var planRows = [];
                var row = new Array(7);
                _.forEach(kurse, function (kurseProStart) {
                    var tag = new Date(kurseProStart.Tag);
                    var index = _.findIndex(vm.weekDates, function (date) {
                        return (date.getFullYear() == tag.getFullYear()) && (date.getMonth() == tag.getMonth()) && (date.getDate() == tag.getDate());
                    });

                    if (_.isNil(row[index]))
                        row[index] = [];
                    row[index].push(kurseProStart);
                });
                planRows.push(row);

                return planRows;

            }
        }

        vm.getKurs = function (kurs, currency) {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });

            if (kurs.AusserhalbBuchungszeitraum || kurs.NichtBuchbar || kurs.Stattgefunden || kurs.Ausgebucht) {
                let reasonNr = null;
                if (kurs.AusserhalbBuchungszeitraum) {
                    reasonNr = 1;
                }
                if (kurs.NichtBuchbar) {
                    reasonNr = 2;
                }
                if (kurs.Stattgefunden) {
                    reasonNr = 3;
                }
                if (kurs.Ausgebucht) {
                    reasonNr = 4;
                    }
                $uibModal.open({
                    templateUrl: "app/Main/views/dialogs/kursplanNichtBuchbarDialog.html",
                    controller: "kursplanNichtBuchbarDialogController",
                    controllerAs: "vm",
                    backdrop: "static",
                    resolve: {
                        data: {reason: reasonNr}
                    }
                });
            }
            if ((!kurs.AusserhalbBuchungszeitraum && !kurs.NichtBuchbar && !kurs.Stattgefunden && !kurs.Ausgebucht)) {
                if(kurs.AllTerminartNutzungsrechte.length > 0) {
                    kurs.LeistungsartenBezeichnungen = [];
                    _.forEach(kurs.AllTerminartNutzungsrechte, function (n) {
                        let name = _.find(vm.nutzungsrechte, {'LeistungsartId': n}).Bezeichnung;
                        kurs.LeistungsartenBezeichnungen.push({Bezeichnung:name})
                    });
                    kurs.LeistungsartenBezeichnung = _.map(kurs.LeistungsartenBezeichnungen, 'Bezeichnung');
                    kurs.Leistungsarten = kurs.AllTerminartNutzungsrechte;
                }
                else {
                    kurs.Leistungsarten = [];
                    kurs.LeistungsartenBezeichnung = [];
                }
                kurs.NutzungsrechteText = kurs.NutzungsrechteMeldung;
                SessionService.setKurs(kurs, vm.currency);
                unregisterEventHandler();
                if (_.isUndefined($stateParams.id)) {
                    var uuid = false;
                } else {
                    var uuid = $stateParams.id;
                }
                kurs.BuchungslimitMitgliedZulassen = vm.layoutSettings.BuchungslimitMitgliedZulassen;

                $state.go('kursbuchungubersicht', {sid: SessionService.getSessionId(), kurs: kurs, cid: $stateParams.cid, id: uuid})
            }
        };

        vm.goToDay = function (day) {
            vm.weekView = false;
            vm.template = "app/Main/views/kursplanDay.html";
            vm.date = new Date(day);
            initPlanDay(day);
        };

    }
]);